// This file is generated by spriteify plugin
export const iconNames = [
  "checkCircle",
  "archive",
  "slidersHorizontal",
  "github",
  "planeTakeoff",
  "creditCard",
  "x",
  "book",
  "upload",
  "arrowLeft",
  "plus",
  "scale",
  "checkCheck",
  "fileDown",
  "pencilLine",
  "uploadCloud",
  "idCard",
  "globe",
  "moon",
  "paintbrush",
  "chevronUp",
  "circleCheck",
  "fileSpreadsheet",
  "rocket",
  "armchair",
  "calendar",
  "clock-5",
  "route",
  "trash",
  "filePieChart",
  "user",
  "refreshCw",
  "fileLineChart",
  "dotsHorizontal",
  "check",
  "info",
  "arrowRight",
  "banknote",
  "server",
  "key",
  "alertTriangle",
  "linkedin",
  "copy",
  "twitter",
  "arrowDownRight",
  "caretUp",
  "userCog",
  "square",
  "star",
  "gauge",
  "caretSort",
  "pencil",
  "cross-1",
  "caretLeft",
  "mapPin",
  "settings",
  "home",
  "stripedLine",
  "dot",
  "users",
  "eye",
  "solidLine",
  "layoutGrid",
  "bell",
  "zap",
  "xCircle",
  "logOut",
  "arrowUpRight",
  "layoutList",
  "magnifyingGlass",
  "menu",
  "filter",
  "puzzle",
  "caretDown",
  "send",
  "sun",
  "caretRight",
  "bookMarked",
  "chevronDown",
  "minus",
  "chevronsUpDown",
] as const;
export type IconName = typeof iconNames[number];